import { useState } from "react";

export function CompulsorySubjects({ subjects }) {
  if (!subjects?.length) return null;

  const totalMarks = subjects.reduce((sum, subject) => sum + subject.marks, 0);

  return (
    <div className="subject-shell">
      <div className="subject-summary">
        <strong>{subjects.length} compulsory papers</strong>
        <span>{totalMarks} marks</span>
      </div>
      <div className="compulsory-grid">
        {subjects.map((subject) => (
          <article key={subject.title} className="subject-card">
            <div>
              <strong>{subject.title}</strong>
              <span>{subject.focus}</span>
            </div>
            <em>{subject.marks}</em>
          </article>
        ))}
      </div>
    </div>
  );
}

export function SubjectGroups({ groups }) {
  if (!groups?.length) return null;

  return (
    <div className="subject-groups">
      {groups.map((group) => (
        <article key={group.group} className="group-card">
          <div className="group-card-head">
            <strong>{group.group}</strong>
            <span>{group.rule}</span>
          </div>
          <div className="subject-chip-list">
            {group.subjects.map((subject) => (
              <span key={`${group.group}-${subject}`}>{subject}</span>
            ))}
          </div>
        </article>
      ))}
    </div>
  );
}

function calculateAgeOnCutoff(dateOfBirth, targetYear) {
  if (!dateOfBirth) return null;

  const birthDate = new Date(`${dateOfBirth}T00:00:00`);
  if (Number.isNaN(birthDate.getTime())) return null;

  const cutoffDate = new Date(Number(targetYear) - 1, 11, 31);
  let age = cutoffDate.getFullYear() - birthDate.getFullYear();
  const birthdayPassed =
    cutoffDate.getMonth() > birthDate.getMonth() ||
    (cutoffDate.getMonth() === birthDate.getMonth() && cutoffDate.getDate() >= birthDate.getDate());

  if (!birthdayPassed) {
    age -= 1;
  }

  return age;
}

export function EligibilityTool() {
  const [dateOfBirth, setDateOfBirth] = useState("");
  const [targetYear, setTargetYear] = useState("2027");
  const [attempts, setAttempts] = useState("0");
  const [hasDegree, setHasDegree] = useState("yes");

  const age = calculateAgeOnCutoff(dateOfBirth, targetYear);
  const attemptCount = Number(attempts);
  const ageReady = age !== null && age >= 21 && age <= 30;
  const attemptsReady = attemptCount >= 0 && attemptCount < 3;
  const degreeReady = hasDegree === "yes";
  const hasEnoughData = age !== null && attempts !== "";
  const looksReady = hasEnoughData && ageReady && attemptsReady && degreeReady;

  return (
    <div className="eligibility-tool">
      <div className="tool-grid">
        <label>
          Date of birth
          <input type="date" value={dateOfBirth} onChange={(event) => setDateOfBirth(event.target.value)} />
        </label>
        <label>
          CSS target year
          <input
            type="number"
            min="2027"
            max="2035"
            value={targetYear}
            onChange={(event) => setTargetYear(event.target.value)}
          />
        </label>
        <label>
          Attempts already used
          <input
            type="number"
            min="0"
            max="3"
            value={attempts}
            onChange={(event) => setAttempts(event.target.value)}
          />
        </label>
        <label>
          Bachelor’s degree ready?
          <select value={hasDegree} onChange={(event) => setHasDegree(event.target.value)}>
            <option value="yes">Yes</option>
            <option value="no">Not yet</option>
          </select>
        </label>
      </div>
      <div className={`tool-result ${looksReady ? "ready" : "review"}`}>
        <strong>{looksReady ? "Planning status: looks ready" : "Planning status: review needed"}</strong>
        <span>
          {age === null
            ? "Enter your date of birth to estimate your age on the CSS cutoff."
            : `Estimated age on 31 Dec ${Number(targetYear) - 1}: ${age}. Attempts remaining: ${Math.max(0, 3 - attemptCount)}.`}
        </span>
      </div>
    </div>
  );
}
